export const Envs = {
  BFF_WEB_URL: process.env['NX_BFF_WEB_URL'] ?? process.env['REACT_APP_HUB_API'],
  BFF_MEMBERS_AREA_URL: process.env['REACT_APP_BFF_MEMBERS_AREA_URL'] ?? process.env['NX_BFF_MEMBERS_AREA_URL'],
  BFF_MEMBER_PORTAL_URL: process.env['NX_BFF_MEMBER_PORTAL_URL'] ?? process.env['REACT_APP_BFF_MEMBER_PORTAL_URL'],
  SITE_URL: process.env['NX_SITE_URL'] ?? process.env['NEXT_PUBLIC_SITE_URL'] ?? process.env['REACT_APP_SITE_URL'],
}
